// eslint-disable-next-line import/no-unresolved -- this package does exists, just not getting picked up by eslint
import AwsApiClient from '@lessonnine/api-client.js/compat'
import { APIGATEWAY_BASE_URL, AWS_SESSION_ENDPOINT, AWS_SESSION_METHOD } from 'src/dataLayer/env'

const awsApiClient = new AwsApiClient({
  awsSessionEndpoint: AWS_SESSION_ENDPOINT,
  awsSessionMethod: AWS_SESSION_METHOD,
  baseUrl: APIGATEWAY_BASE_URL,
})

export default awsApiClient
